import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Menus.css";

const menuData = [
  {
    key: "canapeMenu",
    image: "/menu_bg/canape-menu.png",
    link: "/pdf/canape-menu.pdf"
  },
  {
    key: "chineseMenu",
    image: "/menu_bg/chinese-menu.png",
    link: "/pdf/chinese-menu.pdf"
  },
  {
    key: "westernMenu",
    image: "/menu_bg/western-menu.png",
    link: "/pdf/western-menu.pdf",
    leak: "48,30,30" // warm wine red
  },
  {
    key: "vegeMenu",
    image: "/menu_bg/vegie-menu.png",
    link: "/pdf/vegetarian-menu.pdf",
    leak: "34,48,34" // faint forest green
  },
];

const Menus = () => {
  const { t } = useTranslation();

  return (
    <section id="menus" className="menus-section py-5" data-aos="fade-up">
      <Container>
        <h2 className="section-title text-center mb-5">
          {t('ourMenus')}
          <div className="underline"></div>
        </h2>
        <Row className="g-4">
          {menuData.map((menu, idx) => {
            // Check if this is the last item and it's the only one in its row
            const isLastSingle =
              idx === menuData.length - 1 && menuData.length % 4 === 1;

            return (
              <Col
                key={idx}
                md={3}
                className={isLastSingle ? "offset-md-4" : ""}
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <div
                  className="menu-banner position-relative overflow-hidden rounded-3"
                  {...(menu.leak ? { "data-leak": menu.leak } : {})}
                  style={{ backgroundImage: `url(${menu.image})` }}
                >
                  <div className="menu-overlay d-flex flex-column justify-content-center align-items-center text-white">
                    <h3 className="mb-3">{t(menu.key)}</h3>
                    <Button
                      variant="outline-light"
                      href={menu.link}
                      target="_blank"
                      className="fw-semibold px-4 py-2 border-2 custom-menu-btn"
                    >
                      {t("viewPdf")}
                    </Button>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Menus;